import React, { Fragment, useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";
import {
  useCreateUserMappingMutation,
  useDeleteUserMappingParentOrChildMutation,
  useGetAllMappingDetailsCountMutation,
  useGetAllMappingDetailsMutation,
  useBulkAddUserMappingMutation,
} from "../../../features/tenant/userMapping/userMappingApi";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { Menu } from "@headlessui/react";
import { TiDeleteOutline, TiUserAddOutline } from "react-icons/ti";
import toast from "react-hot-toast";
import { useFetchUserByUserTypeMutation } from "../../../features/tenant/appUsers/appUsersApi";
import { getLoginUserData } from "../../../utils/getLoginUserData";
import TenantSlugs from "../../../utils/TenantSlug";
import { downloadSampleCSV } from "../../../utils/downloadSampleCsv";

const DetailRow = ({ label, value }) => (
  <div className="flex justify-between py-1 text-sm border-b last:border-0">
    <span className="font-medium text-gray-600">{label}</span>
    <span className="text-gray-800">{value || "-"}</span>
  </div>
);

function parseCSV(string) {
  if (!string) return [];
  const lines = string.split(/\r?\n|\r/).filter(line => line.trim() !== "");
  if (lines.length === 0) return [];

  const csvHeader = lines[0].replace(/\s/g, "").split(",");
  const csvRows = lines.slice(1);

  const array = csvRows
    .map((row) => {
      const values = [];
      let insideQuotes = false;
      let currentField = "";

      for (let char of row) {
        if (char === "," && !insideQuotes) {
          values.push(currentField.trim());
          currentField = "";
        } else if (char === '"') {
          insideQuotes = !insideQuotes;
        } else {
          currentField += char;
        }
      }

      values.push(currentField.trim());
      return values;
    })
    .filter((values) => values.length === csvHeader.length)
    .map((values) => {
      const obj = csvHeader.reduce((object, header, index) => {
        object[header] = values[index].trim();
        return object;
      }, {});
      return obj;
    });

  return array;
}

const UserMapping = () => {
  const { zone_id: zoneId, zone_name: zoneName } = getLoginUserData();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);

  const [allMappingData, setAllMappingData] = useState([]);
  const [allMappingDataCount, setAllMappingDataCount] = useState(0);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [mobileToDelete, setMobileToDelete] = useState("");
  const [selectedTab, setSelectedTab] = useState("parent");
  const [parentInfo, setParentInfo] = useState({});
  const [childInfo, setChildInfo] = useState({});
  const [parentMobile, setParentMobile] = useState("");
  const [childMobile, setChildMobile] = useState("");
  const [checkUserMappingCount, setCheckUserMappingCount] = useState(null);
  const [bulkErrorData, setBulkErrorData] = useState([]);
  const [showBulkErrorModal, setShowBulkErrorModal] = useState(false);
  const [templateData, setTemplateData] = useState(
    JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.sudama
      ? [
          { "name": "parent_mobile", "label": "9876543210", "maxLength": 10 },
          { "name": "child_mobile",  "label": "9123456789", "maxLength": 10 },
        ]
      : JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.zeel
      ? [
          { "name": "distributor_mobile", "label": "9876543210", "maxLength": 10 },
          { "name": "retailer_mobile",    "label": "9123456789", "maxLength": 10 },
        ]
      : JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.goodwill
      ? [
          { "name": "distributor_mobile", "label": "9876543210", "maxLength": 10 },
          { "name": "retailer_mobile",    "label": "9123456789", "maxLength": 10 },
        ]
      : JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.coronation
        ? [
          { "name": "distributor_mobile", "label": "9876543210", "maxLength": 10 },
          { "name": "retailer_mobile",    "label": "9123456789", "maxLength": 10 },
        ]
        : [
          { "name": "distributor_mobile", "label": "9876543210", "maxLength": 10 },
          { "name": "sales_mobile",       "label": "9123456789", "maxLength": 10 },
        ]
  );

  const initialRequest = {
    mapped_app_user_mobile: "",
    app_user_mobile: "",
    limit: 10,
    offset: 0,
    startDate: "",
    endDate: "",
  };
  const [request, setRequest] = useState(initialRequest);

  const clearFilters = () => {
    setRequest(initialRequest);
  };

  useEffect(() => {
    if (
      request.mapped_app_user_mobile === "" &&
      request.app_user_mobile === ""
    ) {
      fetchuserMappingFunction();
    }
  }, [request]);

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };

  const [
    userMapping,
    {
      data: userMappingData,
      error: userMappingError,
      isLoading: userMappingIsLoading,
    },
  ] = useGetAllMappingDetailsMutation();

  const [
    userMappingCount,
    {
      data: userMappingCountData,
      error: userMappingCountError,
      isLoading: userMappingCountIsLoading,
    },
  ] = useGetAllMappingDetailsCountMutation();


  const [
    deleteUserMappingByMobile,
    {
      data: deleteUserMappingByMobileData,
      error: deleteUserMappingByMobileError,
      isLoading: deleteUserMappingByMobileIsLoading,
    },
  ] = useDeleteUserMappingParentOrChildMutation();

  const [
    fetchAppUserByUserType,
    { data: appUsersData, error: appUsersError, isLoading: appUsersIsLoading },
  ] = useFetchUserByUserTypeMutation();

  const [
    fetchAppChildByUserType,
    { data: appChildData, error: appChildError, isLoading: appChildIsLoading },
  ] = useFetchUserByUserTypeMutation();


  useEffect(() => {

    if (userMappingData?.body?.appUsersList) {
      setAllMappingData(userMappingData?.body?.appUsersList)
    }
  }, [userMappingData])

  useEffect(() => {
    if (userMappingCountData) {
      setAllMappingDataCount(userMappingCountData?.body?.total)
    }

  }, [userMappingCountData])

  const [
    userMappingCsv,
    { data: userMappingCsvData, error: userMappingCsvError, isLoading: userMappingCsvIsLoading },
  ] = useGetAllMappingDetailsMutation();

  const [
    createUserMappingFunc,
    { data: createUserMappingData, error: createUserMappingError },
  ] = useCreateUserMappingMutation();

  const [
    bulkAddUserMapping,
    { data: bulkAddData, error: bulkAddError, isLoading: bulkAddIsLoading },
  ] = useBulkAddUserMappingMutation();

  useEffect(() => {
    // const hasViewPermission = hasPermission("brandList");
    // if (!hasViewPermission) {
    //   navigate(`/genefied/${getVendorName()}/`);
    // }
    fetchuserMappingFunction();
    fetchuserMappingCountFunction();
    // userMappingCsvFunction();
  }, [limit, offset, request]);


  useEffect(() => {
    if (parentMobile.length == 10) {
      fetchAppUserByUserType({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: { mobile: parentMobile },
        zoneId: zoneId,
      });
    } else {
      setParentInfo({})
    }
  }, [parentMobile])

  useEffect(() => {
    if (childMobile.length == 10) {
      fetchAppChildByUserType({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: { mobile: childMobile },
        zoneId: zoneId,
      });
    } else {
      setChildInfo({})
    }
  }, [childMobile])

  useEffect(() => {
    if (!appUsersData) return;
    const list = appUsersData?.body?.appUsersList;

    if (Array.isArray(list) && list.length > 0) {
      setParentInfo(list[0]);
    } else {
      toast.error("User not found");
      setParentInfo({})
    }
  }, [appUsersData, appUsersError]);

  useEffect(() => {
    if (!appChildData) return;
    const list = appChildData?.body?.appUsersList;

    if (Array.isArray(list) && list.length > 0) {
      setChildInfo(list[0]);
    } else {
      toast.error("User not found");
      setChildInfo({})
    }
  }, [appChildData, appChildError]);



  const fetchuserMappingFunction = () => {
    userMapping({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
    });
  };

  const fetchuserMappingCountFunction = () => {
    userMappingCount({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
    });
  };

  const fetchuserMappingCsvFunction = () => {
    const modifiedRequest = {
      ...request,
      limit: null,
      offset: null,
    };
    userMappingCsv({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: modifiedRequest,
    });
  };

  const [csvData, setCsvData] = useState(null);
  useEffect(() => {
    if (userMappingCsvData && userMappingCsvData?.body?.appUsersList) {
      setCsvData(userMappingCsvData?.body?.appUsersList);
    }

    if (userMappingCsvError) {
      setCsvData(null);
    }
  }, [userMappingCsvData, userMappingCsvError]);

  const columns = [
    {
      name: "S.No",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
    },
    {
      name: "Name",
      cell: (row) => row.app_user_name,
      sortable: true,
    },
    {
      name: "Mobile",
      cell: (row) => row.app_user_mobile,
      sortable: true,
    },
    {
      name: "Firm Name",
      cell: (row) => row.firm_name,
      sortable: true,
    },
    {
      name: "User Id",
      cell: (row) => row.app_user_id,
      sortable: true,
    },
    {
      name: "Tagged Person Name",
      cell: (row) => row.mapped_app_user_name,
      sortable: true,
    },
    {
      name: "Tagged Person Mobile",
      cell: (row) => row.mapped_app_user_mobile,
      sortable: true,
    },
    {
      name: "Tagged User Id",
      cell: (row) => row.mapped_app_user_id,
      sortable: true,
    },
    ...JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.aqualite ? [
      {
        name: "Tagged Person Status",
        cell: (row) => (row.is_scanned ? "true" : "false"),
        sortable: true,
      },
      {
        name: "Department",
        cell: (row) => row.designation ?? "-",
        sortable: true,
      }
    ] : [],
    {
      name: "Created At",
      cell: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
    },
  ];

  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
    .color_shades;

  const handleDeleteMapping = () => {
    if (!mobileToDelete) {
      alert("Please enter a valid mobile number.");
      return;
    }

    const confirmDelete = window.confirm(
      `Are you sure you want to delete mapping for ${mobileToDelete}?`
    );

    if (!confirmDelete) return;

    deleteUserMappingByMobile({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        mobile: mobileToDelete,
        type: selectedTab,
      },
    })

    setShowDeleteModal(false);
    setMobileToDelete("");

  };


  useEffect(() => {
    if (deleteUserMappingByMobileData && deleteUserMappingByMobileData?.body) {
      console.log("deleteUserMappingByMobileData", deleteUserMappingByMobileData.body)
      toast.dismiss();
      toast.success(` ${deleteUserMappingByMobileData?.body?.count} Mappings Deleted Successfully`, { id: "deleteUserMappingByMobileData" })
      fetchuserMappingFunction();
      fetchuserMappingCountFunction();
    }

    if (deleteUserMappingByMobileError) {
      toast.dismiss();
      if (deleteUserMappingByMobileError.status == 404) {
        toast.error("No Records Found", { id: "deleteUserMappingByMobileError" })
      } else {
        toast.error("Something went wrong.", { id: "deleteUserMappingByMobileError" })
      }
      fetchuserMappingFunction();
      fetchuserMappingCountFunction();
    }

    if (deleteUserMappingByMobileIsLoading) {
      toast.loading("Please wait..", { id: "deleteUserMappingByMobileIsLoading" })
    }
  }, [deleteUserMappingByMobileData, deleteUserMappingByMobileError, deleteUserMappingByMobileIsLoading]);

  const handleAddMapping = () => {
    if (!parentInfo || !childInfo || !parentMobile || !childMobile) {
      toast.error("Child or Parent Detail Missing")
      return
    }

    const tenantId = JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id;
    if (TenantSlugs.aqualite == tenantId) {
      const validCombo = ["distributor-retailer", "sales-distributor"]

      const mappedCombo = `${parentInfo.user_type}-${childInfo.user_type}`
      if (!validCombo.includes(mappedCombo)) {
        toast.error(`Please add a valid combo "distributor-retailer", "sales-distributor"`)
        return;
      }
    }

    if (TenantSlugs.sudama == tenantId) {
      const validCombo = ["distributor-wholeseller", "dealer-wholeseller"]

      const mappedCombo = `${parentInfo.user_type}-${childInfo.user_type}`
      if (!validCombo.includes(mappedCombo)) {
        toast.error(`Please add a valid combo "distributor-wholeseller", "dealer-wholeseller"`)
        return;
      }
    }

    if (TenantSlugs.zeel == tenantId) {
      const validCombo = ["distributor-retailer"]

      const mappedCombo = `${parentInfo.user_type}-${childInfo.user_type}`
      if (!validCombo.includes(mappedCombo)) {
        toast.error(`Please add a valid combo "distributor-retailer"`)
        return;
      }
    }

    


    const finalArr = {
      mapped_user_type: parentInfo.user_type,
      mapped_user_type_id: parentInfo.user_type_id,
      mapped_app_user_id: parentInfo.id,
      mapped_app_user_name: parentInfo.name,
      mapped_app_user_mobile: parentInfo.mobile,

      user_type: childInfo.user_type,
      user_type_id: childInfo.user_type_id,
      app_user_id: childInfo.id,
      app_user_name: childInfo.name,
      app_user_mobile: childInfo.mobile,
    }

    console.log("finalArr ", finalArr);

    createUserMappingFunc({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        rows: [finalArr],
      },
    });
  }

  useEffect(() => {
    if (createUserMappingData) {
      console.log("createUserMappingData", createUserMappingData);
      setShowAddModal(false);
      toast.success("Mapping created successfully", {
        id: "createUserMappingData",
      });
      setParentInfo({})
      setChildInfo({})
      setParentMobile("")
      setChildMobile("")
      fetchuserMappingFunction();
      fetchuserMappingCountFunction();
    }

    if (createUserMappingError) {
      console.log("createUserMappingError", createUserMappingError);
      const errMsg =
        createUserMappingError?.data?.message || "Something went wrong";
      toast.error(errMsg, { id: "createUserMappingError" });
    }
  }, [createUserMappingData, createUserMappingError]);

  const handleCsvUpload = (e) => {
    setCsvFile(e.target.files[0]);
  };

  const handleOnSubmit = () => {
    if (!csvFile) {
      toast.error("Please select a file");
      return;
    }

    const fileReader = new FileReader();
    if (csvFile) {
      fileReader.onload = function (event) {
        const text = event.target.result;
        let datas = parseCSV(text);

        console.log("Parsed CSV data:", datas);

        bulkAddUserMapping({
          token: sessionStorage.getItem("access_token"),
          tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
          body: {
            rows: datas,
          },
        });
      };

      fileReader.readAsText(csvFile);
    }
  };

  const downloadCSVFromJSON = (rows, fileName) => {
    if (!rows || rows.length === 0) return;
    const headers = Object.keys(rows[0]);
    const escapeCSV = (value) => {
      if (value === null || value === undefined) return "";
      const str = String(value);
      if (str.includes(",") || str.includes('"') || str.includes("\n")) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };
    const csvRows = [
      headers.join(","),
      ...rows.map((row) => headers.map((field) => escapeCSV(row[field])).join(",")),
    ];
    const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName.endsWith(".csv") ? fileName : fileName + ".csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    if (bulkAddData) {
      toast.dismiss("bulkAddLoading");
      console.log("bulkAddData", bulkAddData);
      setShowUploadModal(false);
      setCsvFile(null);
      toast.success("Bulk mapping created successfully", {
        id: "bulkAddData",
      });
      fetchuserMappingFunction();
      fetchuserMappingCountFunction();
      if (bulkAddData?.body?.errorData && bulkAddData.body.errorData.length > 0) {
        setBulkErrorData(bulkAddData.body.errorData);
        setShowBulkErrorModal(true);
      }
    }

    if (bulkAddError) {
      toast.dismiss("bulkAddLoading");
      console.log("bulkAddError", bulkAddError);
      toast.error("Something went wrong during bulk upload", { id: "bulkAddError" });
    }

    if (bulkAddIsLoading) {
      toast.loading("Uploading...", { id: "bulkAddLoading" });
    }
  }, [bulkAddData, bulkAddError, bulkAddIsLoading]);


  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            All Users Mapping
            <LinksComponent />
          </div>

          <div className="p-3">
            {/* {otpsCsvData && otpsCsvData?.body?.otp && (
              <ExportCSV
                data={otpsCsvData && otpsCsvData?.body?.otp}
                columnsToExport={[
                  "name",
                  "mobile",
                  "otp",
                  "otp_type",
                  "otp_created_at",
                ]}
              />
            )} */}
            <div className="flex justify-start items-center gap-2 mb-2">
              {
                JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.aqualite && (
                  <button
                    className="btn btn-outline-primary clear-both"
                    onClick={() => setShowUploadModal(true)}
                  >
                    Add Distributor to Sales Mapping
                  </button>
                )
              }
              {
                JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.sudama && (
                  <button
                    className="btn btn-outline-primary clear-both"
                    onClick={() => setShowUploadModal(true)}
                  >
                    Add Wholeseller Mapping
                  </button>
                )
              }
              {
                JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.zeel && (
                  <button
                    className="btn btn-outline-primary clear-both"
                    onClick={() => setShowUploadModal(true)}
                  >
                    Add Distributor to Retailer Mapping
                  </button>
                )
              }
              <CustomExport
                fetchData={fetchuserMappingCsvFunction}
                data={csvData}
                defaultColumnExport={[
                  "app_user_name",
                  "app_user_mobile",
                  "mapped_app_user_name",
                  "mapped_app_user_mobile",
                  "created_at",
                ]}
                filename="mapping"
              />
            </div>

            <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
              <div className="flex  space-x-2 justify-end">
                <div className="w-52 h-10">
                  <div className="relative searchin">
                    <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      Parent Mobile
                    </label>
                    <input
                      type="search"
                      id="default-search"
                      className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                      placeholder="Parent Mobile No..."
                      required
                      value={request.app_user_mobile}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setRequest((prevState) => {
                          return { ...prevState, app_user_mobile: newValue };
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="w-52 h-10">
                  <div className="relative searchin">
                    <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      Child Mobile
                    </label>
                    <input
                      type="search"
                      id="default-search"
                      className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                      placeholder="Child Mobile"
                      required
                      value={request.mapped_app_user_mobile}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setRequest((prevState) => {
                          return {
                            ...prevState,
                            mapped_app_user_mobile: newValue,
                          };
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="w-52 ">
                  <div className="relative searchin">
                    <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      From Date
                    </label>
                    <input
                      type="date"
                      id="default-search"
                      className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                      placeholder="Start Date"
                      value={request.startDate}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setRequest((prevState) => {
                          return {
                            ...prevState,
                            startDate: newValue,
                          };
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="w-52 ">
                  <div className="relative searchin">
                    <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      End Date
                    </label>
                    <input
                      type="date"
                      id="default-search"
                      className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                      placeholder="End Date"
                      value={request.endDate}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setRequest((prevState) => {
                          return {
                            ...prevState,
                            endDate: newValue,
                          };
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="flex flex-row  gap-2 h-10">
                  <div className="relative searchin">
                    <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      &nbsp;
                    </label>
                    <button
                      className="py-2 btn btn-outline-primary clear-both float-right  pdbtn_all"
                      onClick={() => {
                        fetchuserMappingFunction();
                        // fetchOtpsCsvFunction();
                      }}
                    >
                      Search
                    </button>
                  </div>
                  <div className="relative searchin">
                    <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      &nbsp;
                    </label>
                    <button
                      className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                      onClick={() => {
                        clearFilters();
                      }}
                    >
                      Clear Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className=" p-3 w-full bg-white shadow rounded-lg">
              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={columns}
                data={allMappingData}
                loading={userMappingIsLoading}
                totalRows={allMappingDataCount}
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
                striped
                highlightOnHover
                pointerOnHover
                pagination
              ></DataTableComponent>
              {true && (
                <div
                  className="fixed bottom-16 right-16 w-16 h-16 mr-10 mb-2 cursor-pointer"
                  id="box_btn"
                >
                  <div className="text-right">
                    <Menu className="relative inline-block text-left">
                      <div>
                        <Menu.Button
                          onClick={() => setShowDeleteModal(true)}
                          className="inline-flex justify-cente w-12 h-12 rounded-full text-sm font-medium bg-red-500 text-white hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 "
                        >
                          <TiDeleteOutline className="w-full h-full p-1.5" />
                        </Menu.Button>
                      </div>
                    </Menu>
                  </div>
                </div>
              )}
              {true && (
                <div
                  className="fixed bottom-0 right-16 w-16 h-16 mr-10 mb-2 cursor-pointer"
                  id="box_btn"
                >
                  <div className="text-right">
                    <Menu className="relative inline-block text-left">
                      <div>
                        <Menu.Button
                          onClick={() => setShowAddModal(true)}
                          className="inline-flex justify-cente w-12 h-12 rounded-full text-sm font-medium bg-red-500 text-white hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 "
                        >
                          <TiUserAddOutline className="w-full h-full p-1.5" />
                        </Menu.Button>
                      </div>
                    </Menu>
                  </div>
                </div>
              )}
            </div>
            {showDeleteModal && (
              <ModalComponent
                size={"md"}
                show={showDeleteModal}
                setShow={setShowDeleteModal}
              >
                <div className="bg-white p-6 rounded-lg shadow-lg">
                  <h2 className="text-lg font-bold mb-4">Delete Mapping</h2>

                  {/* Tab Selection */}
                  <div className="flex border-b mb-4">
                    <button
                      onClick={() => setSelectedTab("parent")}
                      className={`px-4 py-2 text-sm font-medium ${selectedTab === "parent"
                        ? "border-b-2 border-blue-600 text-blue-600"
                        : "text-gray-500"
                        }`}
                    >
                      Parent
                    </button>
                    <button
                      onClick={() => setSelectedTab("child")}
                      className={`px-4 py-2 text-sm font-medium ${selectedTab === "child"
                        ? "border-b-2 border-blue-600 text-blue-600"
                        : "text-gray-500"
                        }`}
                    >
                      Child
                    </button>
                  </div>

                  <p className="mb-2 text-sm text-gray-600">
                    Enter {selectedTab === "parent" ? "Parent" : "Child"} Mobile Number:
                  </p>
                  <input
                    type="text"
                    className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none"
                    placeholder={`Enter ${selectedTab === "parent" ? "Parent" : "Child"} Mobile Number`}
                    value={mobileToDelete}
                    maxLength={10}
                    onChange={(e) => setMobileToDelete(e.target.value)}
                  />
                  <div className="flex justify-end gap-2">
                    <button
                      onClick={() => setShowDeleteModal(false)}
                      className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded hover:bg-gray-100"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleDeleteMapping}
                      className="px-4 py-2 text-sm text-white bg-red-600 rounded hover:bg-red-700"
                    >
                      Delete
                    </button>
                  </div>
                </div>

              </ModalComponent>
            )}

            {showAddModal && (
              <ModalComponent
                size={"xxl"}
                show={showAddModal}
                setShow={setShowAddModal}
              >
                <div className="bg-white p-6 rounded-xl shadow-xl">
                  <h2 className="text-xl font-semibold text-gray-800 mb-4">
                    Add Parent–Child Mapping
                  </h2>

                  {/* Form Container */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                    {/* Parent Section */}
                    <div className="border rounded-lg p-4 shadow-sm bg-gray-50">
                      <h3 className="text-md font-bold text-blue-700 mb-2">{
                        JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.sudama ?
                          "Distributor / Direct Dealer (Bill to)"
                          : JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.zeel ?
                          "Distributor Details"
                          : "Parent Details"
                      }</h3>

                      <label className="text-sm text-gray-600">Mobile Number</label>
                      <input
                        type="text"
                        maxLength={10}
                        value={parentMobile}
                        onChange={(e) => setParentMobile(e.target.value)}
                        placeholder="Enter Parent Mobile Number"
                        className="w-full mt-1 mb-3 border rounded-md px-3 py-2 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none"
                      />

                      {/* Display Fetched Parent Details */}
                      {parentInfo && (
                        <div className="rounded-md bg-white p-3 border">
                          <DetailRow label="Name" value={parentInfo?.name} />
                          <DetailRow label="Type" value={parentInfo?.user_type} />
                          <DetailRow label="Phone" value={parentInfo?.mobile} />
                          <DetailRow label="User ID" value={parentInfo?.user_id} />
                          <DetailRow label="Firm Name" value={parentInfo?.firm_name} />
                        </div>
                      )}
                    </div>

                    {/* Child Section */}
                    <div className="border rounded-lg p-4 shadow-sm bg-gray-50">
                      <h3 className="text-md font-bold text-green-700 mb-2">{
                        JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.sudama ?
                          "WholeSaler (Ship To)"
                          : JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.zeel ?
                          "Retailer Details"
                          : "Child Details"
                      }</h3>

                      <label className="text-sm text-gray-600">Mobile Number</label>
                      <input
                        type="text"
                        maxLength={10}
                        value={childMobile}
                        onChange={(e) => setChildMobile(e.target.value)}
                        placeholder="Enter Child Mobile Number"
                        className="w-full mt-1 mb-3 border rounded-md px-3 py-2 focus:border-green-500 focus:ring-1 focus:ring-green-500 outline-none"
                      />

                      {/* Display Fetched Child Details */}
                      {childInfo && (
                        <div className="rounded-md bg-white p-3 border">
                          <DetailRow label="Name" value={childInfo?.name} />
                          <DetailRow label="Type" value={childInfo?.user_type} />
                          <DetailRow label="Phone" value={childInfo?.mobile} />
                          <DetailRow label="User ID" value={childInfo?.user_id} />
                          <DetailRow label="Firm Name" value={childInfo?.firm_name} />
                        </div>
                      )}
                    </div>

                  </div>

                  {/* Footer Buttons */}
                  <div className="flex justify-end gap-3 mt-6">
                    <button
                      onClick={() => setShowAddModal(false)}
                      className="px-4 py-2 text-sm text-gray-700 border rounded hover:bg-gray-100 transition"
                    >
                      Cancel
                    </button>

                    <button
                      onClick={handleAddMapping}
                      className="px-4 py-2 text-sm text-white bg-blue-600 rounded hover:bg-blue-700 transition"
                    >
                      Save Mapping
                    </button>
                  </div>
                </div>
              </ModalComponent>
            )}

            {showUploadModal && (
              <ModalComponent
                size={"md"}
                show={showUploadModal}
                setShow={setShowUploadModal}
              >
                <div className="w-full p-4">
                  {templateData && templateData?.length > 0 && (
                    <div className="flex justify-center mt-3">
                      <button
                        type="submit"
                        className="mb-3 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                        onClick={() => downloadSampleCSV(templateData)}
                      >
                        Sample Csv Download
                      </button>
                    </div>
                  )}
                  <div className="w-full m-auto justify-center">
                    <div className="flex items-center justify-center w-full">
                      <label
                        htmlFor="dropzone-file"
                        className="flex flex-col items-center justify-center w-full h-20 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                      >
                        <div className="flex flex-col items-center justify-center">
                          <svg
                            aria-hidden="true"
                            className="w-20 h-20 mb-3 text-gray-400 mt-2"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                            ></path>
                          </svg>
                          <p className="mb-2 text-sm text-gray-500 text-center">
                            <span className="font-semibold">Choose CSV file</span>
                            <div>Click to upload or drag and drop</div>
                          </p>
                        </div>
                        <input
                          id="dropzone-file"
                          type="file"
                          className="hidden"
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          onChange={handleCsvUpload}
                        />
                      </label>
                    </div>
                  </div>
                  {templateData && templateData?.length > 0 ? (
                    <div className="flex justify-center mt-3">
                      <button
                        type="submit"
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                        onClick={handleOnSubmit}
                      >
                        Add
                      </button>
                    </div>
                  ) : (
                    <div className="text-red-500 rounded-lg text-sm px-5 py-2.5 text-center">
                      No Template Found !
                    </div>
                  )}
                </div>
              </ModalComponent>
            )}


            {showBulkErrorModal && (
              <ModalComponent
                size={"4xl"}
                show={showBulkErrorModal}
                setShow={(action) => {
                  if (!action) {
                    setBulkErrorData([]);
                    setShowBulkErrorModal(false);
                  }
                }}
              >
                <div className="w-full p-4">
                  <div className="flex justify-between items-center mb-3">
                    <div className="text-xl font-bold">
                      Bulk Upload — Error Rows ({bulkErrorData.length})
                    </div>
                    <button
                      className="btn btn-outline-primary"
                      onClick={() =>
                        downloadCSVFromJSON(
                          bulkErrorData,
                          `mapping_error_rows_${new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19)}.csv`
                        )
                      }
                    >
                      Download CSV
                    </button>
                  </div>
                  <DataTableComponent
                    columns={[
                      {
                        name: "SNo",
                        cell: (row, idx) => idx + 1,
                        width: "70px",
                      },
                      {
                        name: "Parent Mobile",
                        cell: (row) => row.parentMobile || "-",
                        sortable: true,
                        width: "160px",
                      },
                      {
                        name: "Child Mobile",
                        cell: (row) => row.childMobile || "-",
                        sortable: true,
                        width: "160px",
                      },
                      {
                        name: "Reason",
                        cell: (row) => row.reason,
                        sortable: false,
                        wrap: true,
                      },
                    ]}
                    data={bulkErrorData}
                    pagination={false}
                  />
                </div>
              </ModalComponent>
            )}


          </div>
        </div>
      </div>
    </>
  );
};

export default UserMapping;
